import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { useMemo } from "react";

export function usePostRuleLevel() {
  const url = useMemo(() => `rule_levels`, []);

  const { loading, error, data, postCallback } = useFetchPostV2(url);

  return {
    loading,
    error,
    data,
    postRuleLevelCallback: postCallback
  };
}
